import React, { useMemo } from 'react';
import { Control } from 'react-hook-form';

import { IsDisabled } from '../../../../../../../types';

import { OperationFields } from '../../../../../operationsTypes';

import { NoTATFormData } from '../../NoTATForm.types';

import {
  FetchCategoriesScopes,
  FetchCategoriesSortTypes
} from '../../../../../../categories/categoriesTypes';

import { SelectOptionType } from '../../../../../../../helpers/Select';

import {
  FetchCategoriesSelectFieldQueryResponse,
  FETCH_CATEGORIES_SELECT_FIELD_QUERY
} from '../../../../../../categories/queries/fetchCategoriesSelectField.query';
import { CACHE_FETCH_CATEGORIES_SELECT_FIELD_QUERY } from '../../../../../../categories/queries/fetchCacheCategoriesSelectField.query';

import { useFinPaginatedCategories } from '../../../../../../categories/hooks/useFinPaginatedCategories';

import { SelectField } from '../../../../../../../helpers/FormFields/SelectField';

import { operationsKeys } from '../../../../../../../locales/keys';

import { CategoryCache } from '../../../../../../categories/CategoryCache';

interface NoTATFormRecordFieldProps {
  control: Control<NoTATFormData>;
  error?: string | null;
  disabled?: IsDisabled;
}

function NoTATFormRecordField({
  control,
  error,
  disabled
}: NoTATFormRecordFieldProps) {
  const { categories } =
    useFinPaginatedCategories<FetchCategoriesSelectFieldQueryResponse>({
      query: FETCH_CATEGORIES_SELECT_FIELD_QUERY,
      cacheQuery: CACHE_FETCH_CATEGORIES_SELECT_FIELD_QUERY,
      cacheKey: CategoryCache.categoriesSelectFieldCacheKey(
        FetchCategoriesScopes.T_A_T
      ),
      initialFilters: {
        scope: { eq: FetchCategoriesScopes.T_A_T }
      },
      initialLimit: 1000,
      initialSort: [FetchCategoriesSortTypes.CREATED_AT_ASC],
      options: { withoutPrefetch: true }
    });

  const options = useMemo<SelectOptionType<string>[]>(
    () =>
      categories.map((category) => ({
        label: category.name,
        value: category.name
      })),
    [categories]
  );

  return (
    <SelectField
      error={error}
      control={control}
      disabled={disabled}
      i18nLabel={operationsKeys.record}
      name={OperationFields.BODY}
      labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
      options={options}
    />
  );
}

export default NoTATFormRecordField;
